// extracted by css-extract-rspack-plugin
export default {"CommentClamp":"CommentActionCollapsed-module__CommentClamp__PtUOu"};